/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */
// Composables
import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#117873',
          'on-primary': '#FFFFFF',
          secondary: '#B2DFDB',
          'on-secondary': '#004D40',
        },
      },
    },
  },

  defaults: {
    VTextField: { color: 'primary' },
    VTextarea: { color: 'primary' },
    VSelect: { color: 'primary' },
    VAutocomplete: { color: 'primary' },
    VCombobox: { color: 'primary' },
    VDateInput: { color: 'primary' },
    VNumberInput: { color: 'primary' },
    VFileInput: { color: 'primary' },
    VCheckbox: { color: 'primary' },
    VRadioGroup: { color: 'primary' },
    VSwitch: { color: 'primary' },
  },

  components: {
    ...components,
    ...labsComponents,
    ...directives
  },
})
